import { useState } from 'react'

const useFiltersModal = () => {
  const [showFiltersModal, setShowFiltersModal] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState(null)

  const onClickInFilterChip = filterName => {
    setSelectedFilter(filterName)
    setShowFiltersModal(true)
  }

  const onCloseFiltersModal = () => {
    setSelectedFilter(null)
    setShowFiltersModal(false)
  }

  const onOpenFiltersModal = () => {
    setShowFiltersModal(true)
  }

  return {
    showFiltersModal,
    selectedFilter,
    setShowFiltersModal,
    setSelectedFilter,
    onClickInFilterChip,
    onCloseFiltersModal,
    onOpenFiltersModal,
  }
}

export default useFiltersModal
